import {createContext, ReactNode, useContext} from "react";
import {useAuth} from "@jane/lib/src/auth/hook";
import {useApiEndpoint} from "../../../lib/src/api";
import {useApiCall} from "@jane/lib/src/api";
import {config} from "../config";
import {Profile} from "../../../lib/src/api/repositories/profile-repository";

interface ProfileContextType {
  profile: Profile|null
  isLoading: boolean
  error: string|undefined
}

export const ProfileContext = createContext<ProfileContextType>({} as ProfileContextType)

export function ProfileContextProvider({ children } : {children: ReactNode}): ReactNode {
  const { isLoggedIn } = useAuth()

  const { profile } = useApiCall(config)
  const { resource, isLoading, error } = useApiEndpoint(() => profile.me(), isLoggedIn)

  if (resource === undefined) {
    return <></>
  }

  return <ProfileContext.Provider value={({
    profile: resource ?? null,
    isLoading,
    error: (typeof(error) === "string") ? error : undefined,
  })}>{ children }</ProfileContext.Provider>
}

export function useProfileData(): ProfileContextType {
  return useContext(ProfileContext)
}